import React, { useEffect, useState } from 'react';
import { Table, Button, Group, Text, Paper, Title, Modal, Stack } from '@mantine/core';
import * as api from '../../api/index';
import { toast } from 'react-toastify';

const ContactQueries = () => {
    const [contacts, setContacts] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);

    const fetchContacts = async () => {
        try {
            const { data } = await api.fetchContacts();
            setContacts(data.data);
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch contacts");
        }
    };

    useEffect(() => {
        fetchContacts();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this query?")) return;
        try {
            await api.deleteContact(id);
            toast.success("Query deleted");
            fetchContacts();
        } catch (error) {
            console.error(error);
            toast.error("Failed to delete query");
        }
    };

    const rows = contacts.map((contact) => (
        <tr key={contact._id}>
            <td>{new Date(contact.createdAt).toLocaleDateString()}</td>
            <td>{contact.name}</td>
            <td>{contact.email}</td>
            <td>{contact.subject || '-'}</td>
            <td>
                <Group spacing="xs">
                    <Button size="xs" variant="light" onClick={() => setSelectedContact(contact)}>
                        <i className="fas fa-eye"></i>
                    </Button>
                    <Button size="xs" color="red" variant="light" onClick={() => handleDelete(contact._id)}>
                        <i className="fas fa-trash"></i>
                    </Button>
                </Group>
            </td>
        </tr>
    ));

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                   <Title order={2} mb="lg">Contact Queries</Title>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <Paper p="md" shadow="xs">
                        <Table striped highlightOnHover>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Subject</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </Table>
                    </Paper>
                </div>
            </section>

             <Modal opened={!!selectedContact} onClose={() => setSelectedContact(null)} title="Message Details">
                {selectedContact && (
                    <Stack>
                        <Group><Text weight={700}>From:</Text> <Text>{selectedContact.name} ({selectedContact.email})</Text></Group>
                        <Group><Text weight={700}>Phone:</Text> <Text>{selectedContact.phone || 'N/A'}</Text></Group>
                        <Group><Text weight={700}>Subject:</Text> <Text>{selectedContact.subject}</Text></Group>
                        <Text weight={700}>Message:</Text>
                        <Paper p="sm" withBorder bg="gray.0">
                            <Text>{selectedContact.message}</Text>
                        </Paper>
                    </Stack>
                )}
            </Modal>
        </div>
    );
}

export default ContactQueries;
